export class IdCampiCtxMenu {
  public static readonly DATI_GENERALI_PRATICA: string =
    'dati_generali_pratica';
  public static readonly PRATICHE_CORRELATE_PRATICA: string =
    'pratiche_correlate_pratica';
  public static readonly PRATICHE_RIUNITE: string = 'pratiche_riunite';
  public static readonly PRATICHE_PRECEDENTI: string =
    'pratiche_precedenti_pratica';

  public static readonly COPERTINA_FASCICOLO: string = 'copertina_fascicolo';
  public static readonly DATI_GENERALI_FASCICOLO: string =
    'dati_generali_fascicolo';
  public static readonly CONTROPARTI_FASCICOLO: string =
    'controparti_fascicolo';
  public static readonly SEZIONE_PATOLOGIE: string = 'patologie_fascicolo';
  public static readonly SCHEDE_RECUPERO_FASCICOLO: string =
    'schede_recupero_fascicolo';
  public static readonly SCHEDE_ESECUZIONE_FASCICOLO: string =
    'schede_esecuzione_fascicolo';
  public static readonly LEGALI_FASCICOLO: string = 'legali_fascicolo';
  public static readonly ALTRE_PARTI_FASCICOLO: string =
    'altre_parti_fascicolo';
  public static readonly SEZIONE_ECONOMICA_FASCICOLO: string =
    'sezione_economica_fascicolo';
  public static readonly SCADENZARIO_FASCICOLO: string =
    'scadenzario_fascicolo';
  public static readonly ATTI_FASCICOLO: string = 'atti_fascicolo';
  public static readonly ESITI_FASCICOLO: string = 'esiti_fascicolo';
  public static readonly PAGAMENTI_FASCICOLO: string = 'pagamenti_fascicolo';
  public static readonly INCASSI_FASCICOLO: string = 'incassi_fascicolo';
  public static readonly FATTURE_FASCICOLO: string = 'fatture_fascicolo';
  public static readonly PARCELLE_GIUDIZIALI_FASCICOLO: string =
    'parcelle_fascicolo'; // 'parcelle_giudiziali_fascicolo';
  public static readonly PARCELLE_STRAGIUDIZIALI_FASCICOLO: string =
    'parcelle_fascicolo'; // 'parcelle_stragiudiziali_fascicolo';
    public static readonly CENSIMENTO_DOCUMENTI_FASCICOLO: string =
    'censimento_documenti_fascicolo';
  public static readonly ASSEGNATARI_FASCICOLO: string =
    'assegnatari_fascicolo';
  public static readonly DOCUMENTAZIONE_ALLEGATA_FASCICOLO: string =
    'documentazione_allegata_fascicolo';

  public static readonly DATI_GENERALI_PRATICA_CREATE: string =
    'dati_generali_pratica_create';
  public static readonly DATI_GENERALI_PRATICA_INS: string =
    'dati_generali_pratica';
  public static readonly DATI_GENERALI_FASCICOLO_CREATE: string =
    'dati_generali_fascicolo_create';
  public static readonly DATI_GENERALI_FASCICOLO_INS: string =
    'dati_generali_fascicolo';

  public static readonly CONTROPARTI_FASCICOLO_INS: string =
    'controparti_fascicolo';
  public static readonly SEZIONE_PATOLOGIE_INS: string = 'patologie_fascicolo';
  public static readonly ALTRE_PARTI_FASCICOLO_INS: string =
    'altre_parti_fascicolo';
  public static readonly SEZIONE_ECONOMICA_FASCICOLO_INS: string =
    'sezione_economica_fascicolo';
  public static readonly ATTI_FASCICOLO_INS: string = 'atti_fascicolo';
  public static readonly SCADENZARIO_FASCICOLO_INS: string =
    'scadenzario_fascicolo';
  public static readonly DOCUMENTAZIONE_ALLEGATA_FASCICOLO_INS: string =
    'documentazione_allegata_fascicolo';
  public static readonly ASSEGNAZIONE_PER_SMISTAMENTO_INS: string =
    'assegnazione_per_smistamento';
  public static readonly ASSEGNAZIONE_PER_COMPETENZA_INS: string =
    'assegnazione_per_competenza';
  public static readonly LEGALI_FASCICOLO_INS: string = 'legali_fascicolo';

  public static readonly BENI_MOBILI: string = 'beni_pignorati_mobili';
  
  public static readonly TITOLI_PROVE_SCRITTE_FASCICOLO: string =
  'titoli_prove_scritte_fascicolo';
  public static readonly BENI_IMMOBILI: string = 'beni_immobili_fascicolo';
  public static readonly LETTERE_DIFFIDA_FASCICOLO: string =
  'lettere_diffida_fascicolo';
  public static readonly DATI_PIGNORAMENTO: string = 'dati_pignoramento';
  public static readonly BANCHE_DATI_FASCICOLO: string = 'banchedati_fascicolo';
  public static readonly BANCHE_DATI_FASCICOLO_INS: string = 'banchedati_fascicolo';
  public static readonly EVENTI_CANCELLERIA_FASCICOLO: string = "eventicancelleria_fascicolo";
  public static readonly REATI_FASCICOLO: string = 'reati_fascicolo';

}
